import React, { useState } from 'react';
import { FeatureBadge } from './FeatureBadge';
import { SparklesIcon, LeafIcon, SmileIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export function ProductHero() {
  const [activeImage, setActiveImage] = useState(0);
  const productImages = [{
    url: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/Gemini_Generated_Image_udwxs3udwxs3udwx.png?v=1764371032',
    alt: 'Faith & Fig Divine Wellness - Front View'
  }, {
    url: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/Gemini_Generated_Image_h4n8d0h4n8d0h4n8.png?v=1764371125',
    alt: 'Faith & Fig Divine Wellness - With Powder'
  }, {
    url: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/Gemini_Generated_Image_5p98y85p98y85p98.png?v=1763928093',
    alt: 'Faith & Fig Divine Wellness - Back View'
  }, {
    url: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/Gemini_Generated_Image_45yi345yi345yi34.png?v=1764371374',
    alt: 'Faith & Fig Divine Wellness - Back View'
  }];
  const getVisibleThumbnails = () => {
    const totalImages = productImages.length;
    let startIndex = Math.max(0, activeImage - 1);
    if (startIndex + 3 > totalImages) {
      startIndex = totalImages - 3;
    }
    return productImages.slice(startIndex, startIndex + 3).map((img, idx) => ({
      ...img,
      originalIndex: startIndex + idx
    }));
  };
  const handlePrevImage = () => {
    setActiveImage(prev => prev === 0 ? productImages.length - 1 : prev - 1);
  };
  const handleNextImage = () => {
    setActiveImage(prev => prev === productImages.length - 1 ? 0 : prev + 1);
  };
  return <div className="w-full" data-id="element-345">
      {/* === MOBILE LAYOUT (Grid) === */}
      <div className="lg:hidden w-full grid grid-cols-[72%_26%] gap-2" data-id="element-346">
        {/* Column 1: Image (Driver of Height) */}
        <div className="relative aspect-square w-full" data-id="element-347">
          {/* Badge */}
          <div className="absolute -top-2 left-2 z-20" data-id="element-348">
            <span className="bg-[#c4d4c0] text-[#2d4a3a] text-[9px] font-bold px-2 py-1 rounded uppercase tracking-wide shadow-lg" data-id="element-349">
              Joint & Mobility
            </span>
          </div>

          {/* 90% Badge */}
          <div className="absolute -top-3 -right-3 bg-[#2d4a3a] text-white rounded-full w-14 h-14 flex flex-col items-center justify-center shadow-2xl z-20" data-id="element-350">
            <div className="text-lg font-bold text-[#d4af37]" data-id="element-351">90%</div>
            <div className="text-[6px] text-center leading-tight px-1 mt-0.5 uppercase" data-id="element-352">
              Feel the
              <br data-id="element-353" />
              benefits
            </div>
          </div>

          {/* Main Image */}
          <div className="w-full h-full bg-white rounded-2xl overflow-hidden shadow-lg relative z-10" data-id="element-354">
            <img src={productImages[activeImage].url} alt={productImages[activeImage].alt} className="w-full h-full object-contain p-3" data-id="element-355" />
          </div>
        </div>

        {/* Column 2: Badges */}
        <div className="flex flex-col justify-start gap-5 h-full py-1" data-id="element-356">
          <div className="w-full overflow-hidden flex justify-center" data-id="element-357">
            <FeatureBadge icon={<SparklesIcon className="w-3 h-3" data-id="element-359" />} label="Clinically-Studied Formula" compact data-id="element-358" />
          </div>
          <div className="w-full overflow-hidden flex justify-center" data-id="element-360">
            <FeatureBadge icon={<LeafIcon className="w-3 h-3" data-id="element-362" />} label="65% Boswellic Acids" compact data-id="element-361" />
          </div>
          <div className="w-full overflow-hidden flex justify-center" data-id="element-363">
            <FeatureBadge icon={<SmileIcon className="w-3 h-3" data-id="element-365" />} label="Pure Formula No fillers. No binders." compact data-id="element-364" />
          </div>
        </div>
      </div>

      {/* === DESKTOP LAYOUT (Flex) === */}
      <div className="hidden lg:flex flex-row items-stretch gap-6" data-id="element-366">
        {/* Left Column: Image */}
        <div className="flex-1 relative" data-id="element-367">
          <div className="absolute -top-3 left-4 z-20" data-id="element-368">
            <span className="bg-[#c4d4c0] text-[#2d4a3a] text-xs font-bold px-3 py-1.5 rounded uppercase tracking-wide shadow-lg" data-id="element-369">
              JOINT & MOBILITY
            </span>
          </div>
          <div className="absolute -top-4 -right-4 bg-[#2d4a3a] text-white rounded-full w-24 h-24 flex flex-col items-center justify-center shadow-2xl z-20" data-id="element-370">
            <div className="text-3xl font-bold text-[#d4af37]" data-id="element-371">90%</div>
            <div className="text-[9px] text-center leading-tight px-2 mt-1 uppercase" data-id="element-372">
              Feel the
              <br data-id="element-373" />
              benefits
            </div>
          </div>
          <div className="aspect-square bg-white rounded-2xl overflow-hidden shadow-lg h-full relative z-10" data-id="element-374">
            <img src={productImages[activeImage].url} alt={productImages[activeImage].alt} className="w-full h-full object-contain p-8" data-id="element-375" />
          </div>
        </div>

        {/* Right Column: Badges */}
        <div className="flex flex-col justify-start gap-3 flex-shrink-0 w-auto py-2" data-id="element-376">
          <FeatureBadge icon={<SparklesIcon className="w-5 h-5" data-id="element-378" />} label="Clinically-Studied Formula" compact data-id="element-377" />
          <FeatureBadge icon={<LeafIcon className="w-5 h-5" data-id="element-380" />} label="65% Boswellic Acids" compact data-id="element-379" />
          <FeatureBadge icon={<SmileIcon className="w-5 h-5" data-id="element-382" />} label="Pure Formula No fillers. No binders." compact data-id="element-381" />
        </div>
      </div>

      {/* THUMBNAILS SECTION */}
      <div className="mt-3 lg:mt-4" data-id="element-383">
        <div className="flex items-center gap-2 lg:gap-3" data-id="element-384">
          <button onClick={handlePrevImage} className="flex-shrink-0 w-8 h-8 lg:w-10 lg:h-10 rounded-full bg-[#496f58] hover:bg-[#3d5a47] text-white flex items-center justify-center transition-all shadow-md" data-id="element-385">
            <ChevronLeftIcon className="w-4 h-4 lg:w-5 lg:h-5" data-id="element-386" />
          </button>

          <div className="flex-1 grid grid-cols-3 gap-2 lg:gap-3" data-id="element-387">
            {getVisibleThumbnails().map(image => <button key={image.originalIndex} onClick={() => setActiveImage(image.originalIndex)} className={`
                  aspect-square bg-white rounded-lg overflow-hidden shadow-md
                  transition-all hover:shadow-lg
                  ${activeImage === image.originalIndex ? 'ring-2 lg:ring-4 ring-[#496f58]' : 'ring-1 ring-gray-200'}
                `} data-id="element-388">
                <img src={image.url} alt={image.alt} className="w-full h-full object-contain p-1 lg:p-2" data-id="element-389" />
              </button>)}
          </div>

          <button onClick={handleNextImage} className="flex-shrink-0 w-8 h-8 lg:w-10 lg:h-10 rounded-full bg-[#496f58] hover:bg-[#3d5a47] text-white flex items-center justify-center transition-all shadow-md" data-id="element-390">
            <ChevronRightIcon className="w-4 h-4 lg:w-5 lg:h-5" data-id="element-391" />
          </button>
        </div>

        <div className="text-center mt-2 text-xs text-gray-500" data-id="element-392">
          {activeImage + 1} / {productImages.length}
        </div>

        {/* TRUST LOGOS */}
        <div className="hidden lg:grid grid-cols-2 gap-6 lg:gap-8 pt-6 lg:pt-8 mt-6 lg:mt-8 border-t border-gray-200" data-id="element-393">
          <div className="text-left" data-id="element-394">
            <div className="font-bold text-xs lg:text-sm mb-1" data-id="element-395">BBC</div>
            <div className="font-serif text-base lg:text-lg font-bold text-gray-900 mb-1 lg:mb-2" data-id="element-396">
              DRAGONS' DEN
            </div>
            <p className="text-[10px] lg:text-xs text-gray-600 italic leading-tight" data-id="element-397">
              "The biblical botanical Christian women are using to restore their
              daily mobility"
            </p>
            <p className="text-[9px] lg:text-[10px] text-gray-400 mt-0.5 lg:mt-1" data-id="element-398">
              Sara Davies, Host
            </p>
          </div>
          <div className="text-left" data-id="element-399">
            <div className="font-serif text-xl lg:text-2xl font-bold text-gray-900 mb-1 lg:mb-2" data-id="element-400">
              Forbes
            </div>
            <p className="text-[10px] lg:text-xs text-gray-600 leading-tight" data-id="element-401">
              "The Most Potent & Effective Frankincense Supplement for Joint
              Comfort yet.."
            </p>
          </div>
        </div>
      </div>
    </div>;
}